import {Action} from "@ngrx/store";
import {IConfiguration} from "../../state/configuration/configuration.state";

export enum EConfigurationActions {
    LoadConfigurationForHost = '[Configuration] Load Configuration For Host',
    LoadConfigurationSuccess = '[Configuration] Load Configuration Success',
    LoadConfigurationFailure = '[Configuration] Load Configuration Failure',

    SetConfigurationHost = '[Configuration] Set Configuration Host'
}

export class LoadConfigurationForHost implements Action {
    public readonly type = EConfigurationActions.LoadConfigurationForHost;

    constructor(public payload: { host: string; protocol: string; port: string}) {
    }
}

export class LoadConfigurationSuccess implements Action {
    public readonly type = EConfigurationActions.LoadConfigurationSuccess;

    constructor(public payload: { configuration: IConfiguration }) {
    }
}

export class LoadConfigurationFailure implements Action {
    public readonly type = EConfigurationActions.LoadConfigurationFailure;

}

export class SetConfigurationHost implements Action {
    public readonly type = EConfigurationActions.SetConfigurationHost;

    constructor(public payload: { host: string }) {
    }
}

export type ConfigurationActions =
    LoadConfigurationForHost |
    LoadConfigurationSuccess |
    LoadConfigurationFailure |
    SetConfigurationHost;


/*
import {Action} from "@ngrx/store";
import {IAccount, IAccountOperation} from "../../models/accounting/accounting.interface";

export enum EAccountingActions {
  GetAccounts = '[Accounting] Get Accounts',
  GetAccountsSuccess = '[Accounting] Get Accounts Success',
  GetAccountsFailure = '[Accounting] Get Accounts Failure'

}
export class GetAccounts implements Action {
  public readonly type = EAccountingActions.GetAccounts;
}
export class GetAccountsSuccess implements Action {
  public readonly type = EAccountingActions.GetAccountsSuccess;
  constructor(public payload: Array<IAccount>){}
}
export class GetAccountsFailure implements Action {
  public readonly type = EAccountingActions.GetAccountsFailure;
}




export type AccountingActions =
  GetAccounts |
  GetAccountsSuccess |
  GetAccountsFailure;

 */
